<span [ngClass]="['flow-badge', 'size-' + size.toLowerCase(), 'type-' + type.toLowerCase(), 'color-' + color.toLowerCase()]" [class.has-left-icon]="!!icon">
  @if (icon) {
    <span class="icon-wrapper" aria-hidden="true">
      <img [src]="icon" class="icon" />
    </span>
  }
  <span agText="body-3-medium">{{ text }}</span>
</span>
